// src/components/LoginPage.jsx
import React from 'react';
import { useMsal } from '@azure/msal-react';
import { loginRequest } from '../auth/authConfig';
import { LogIn } from 'lucide-react';
import InsyncGuardInfo from './InsyncGuardInfo';

export default function LoginPage() {
    const { instance } = useMsal();
    const [isLoading, setIsLoading] = React.useState(false);

    const handleLogin = () => {
        setIsLoading(true);
        instance.loginRedirect(loginRequest).catch((error) => {
            console.error('Login failed:', error);
            setIsLoading(false);
        });
    };

    return (
        <div className="min-h-screen bg-slate-900 flex items-center justify-center font-sans">
            <div className="bg-white rounded-2xl shadow-2xl p-10 max-w-md w-full mx-4 text-center">
                {/* Logo */}
                <div className="flex justify-center mb-6">
                    <img
                        src="/insync-digital-colour.png"
                        alt="Insync Logo"
                        className="h-16 w-16 rounded-xl bg-white p-1 shadow-md"
                    />
                </div>

                <h1 className="text-2xl font-bold text-gray-900 mb-1">Ops Console</h1>
                <p className="text-sm text-gray-500 mb-8">
                    Sign in with your Insync Insurance Microsoft account to continue.
                </p>

                <button
                    onClick={handleLogin}
                    disabled={isLoading}
                    className="w-full flex items-center justify-center gap-3 px-6 py-3 bg-orange-600 hover:bg-orange-700 disabled:bg-orange-400 text-white font-semibold rounded-lg shadow-lg shadow-orange-600/20 transition-all duration-200"
                >
                    <LogIn className="h-5 w-5" />
                    {isLoading ? 'Redirecting...' : 'Sign in with Microsoft'}
                </button>

                <InsyncGuardInfo className="mt-6 text-xs text-gray-400" suffix=" (Microsoft Entra ID)" />
            </div>
        </div>
    );
}
